import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import circleWood from "../../../assets/images/circle_wood_empty.png";

class SingleAvatar extends React.Component{
    constructor() {
        super();
        this.state={
        }
    }
    render() {

        const {icon}=this.props.data
        return (
            <Grid item sm={12} xs={12} alignItems={"center"} justify={'center'} container
                  className='single-avatar'
            >
                <img className='single-avatar-holder' src={circleWood} alt=""/>
                <img className='single-avatar-icon' src={icon} alt=""/>
            </Grid>
        )
    }

}

export default SingleAvatar